import { render } from "./WysiwygEditor.vue?vue&type=template&id=3be6ac01&scoped=true"
import script from "./WysiwygEditor.vue?vue&type=script&lang=js"
export * from "./WysiwygEditor.vue?vue&type=script&lang=js"

import "./WysiwygEditor.vue?vue&type=style&index=0&id=3be6ac01&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be6ac01"]])

export default __exports__